<template>
  <div class="notification-item">
    <el-avatar
      v-if="notification.avatar"
      :src="notification.avatar"
      class="notification-avatar"
      size="medium"
    />
    <div class="notification-content">
      <p class="notification-message">{{ notification.message }}</p>
      <span class="notification-time">{{ formattedTime }}</span>
    </div>
  </div>
</template>

<script>
import { computed } from 'vue';
import { ElAvatar } from 'element-plus';

export default {
  name: 'NotificationItem',
  props: {
    notification: {
      type: Object,
      required: true
    }
  },
  components: {
    ElAvatar
  },
  setup() {
    // Computed property for formatted time display
    const formattedTime = computed(() => {
      return new Date().toLocaleTimeString([], {
        hour: '2-digit',
        minute: '2-digit'
      });
    });

    return { formattedTime };
  }
};
</script>

<style scoped>
.notification-item {
  display: flex;
  align-items: center;
  padding: 10px;
  margin-bottom: 10px;
  background-color: #fff;
  border-radius: 10px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  transition: background-color 0.3s ease;
}

.notification-item:hover {
  background-color: #f0f0f0;
}

.notification-avatar {
  margin-right: 10px;
}

.notification-content {
  flex: 1;
}

.notification-message {
  font-size: 14px;
  font-weight: 500;
  margin: 0;
}

.notification-time {
  display: block;
  font-size: 12px;
  color: #999;
  margin-top: 2px;
}
</style>
